<div class="question">

  <div class="question-panel">

    <div class="form-group">
      <label class="form-group__label">{{ question?.question_prompt }}</label>

      @for (option of options; track option) {
        <label class="selection">
          <input type="radio"
            [name]="uniqueControlName"
            [checked]="selectedValue === option.answer"
            (click)="onSelect(option)">
            <div class="selection__inner">
              <div class="selection__main">
                <div class="selection__content">
                  <div class="selection__indi"><span></span></div>
                  <div class="selection__label">
                    <div class="selection__title">{{ option.answer }}</div>
                  </div>
                </div>
              </div>
              @if (getOptionRows(option)?.length > 0) {
                <div class="selection__drawer">
                  <ul class="data data--options">
                    @for (row of getOptionRows(option); track row) {
                      <li class="data__row">
                        <label class="data__label">{{ row.label }}</label>
                        <div class="data__cell data__cell--right"><strong>{{ row.value }}</strong></div>
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          </label>
        }

      </div>

    </div>

  </div>
